import PropTypes from 'prop-types';
import { BsExclamationTriangle } from 'react-icons/bs';

import Switch from '#globalComponents/Forms/Switch';

import { COMPANY_KIND_VALUES, coversAllCompanyKinds, OPERATING_ONLY } from '../../utils/companyKinds';

const fmt = (value) => Math.round(value ?? 0).toLocaleString('de-DE');

const FulltextTooBroad = ({ warning }) => (
	<p className="flex items-start gap-1.5 text-[11px] leading-snug text-caution-700">
		<BsExclamationTriangle className="mt-0.5 h-3 w-3 flex-shrink-0" />
		<span>
			Der Volltext trifft sehr viele Firmen (ca. {fmt(warning.estimatedMatches)}), die Treffer werden deshalb
			nicht nach Relevanz sortiert. Kombinieren Sie ihn mit engeren Kriterien.
		</span>
	</p>
);

FulltextTooBroad.propTypes = {
	warning: PropTypes.shape({ estimatedMatches: PropTypes.number }).isRequired,
};

const HiddenCompanyKinds = ({ hiddenCount, companyKinds, onChange }) => {
	const includesAll = coversAllCompanyKinds(companyKinds);
	if (!includesAll && !(hiddenCount > 0)) return null;
	return (
		<div className="flex items-center justify-between gap-2 text-[11px] text-bgBase-800">
			<span>
				{includesAll
					? 'Holdings/Verwaltungsgesellschaften eingeblendet'
					: `${fmt(hiddenCount)} Holdings/Verwaltungsgesellschaften ausgeblendet`}
			</span>
			<Switch
				size="sm"
				checked={includesAll}
				onChange={(checked) => onChange(checked ? [...COMPANY_KIND_VALUES] : OPERATING_ONLY)}
				label="einblenden"
			/>
		</div>
	);
};

HiddenCompanyKinds.propTypes = {
	hiddenCount: PropTypes.number,
	companyKinds: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func.isRequired,
};

/**
 * Notes under a search preview: a too-broad full text (no ranking) and the companies the kind
 * filter hides, with a switch that includes all kinds (= no kind filter).
 */
const PreviewNotes = ({ hiddenByCompanyKind, warnings, companyKinds, onCompanyKindsChange }) => {
	const fulltextWarning = warnings?.find((warning) => warning.code === 'FULLTEXT_TOO_BROAD');
	return (
		<>
			{fulltextWarning && <FulltextTooBroad warning={fulltextWarning} />}
			{onCompanyKindsChange && (
				<HiddenCompanyKinds
					hiddenCount={hiddenByCompanyKind}
					companyKinds={companyKinds}
					onChange={onCompanyKindsChange}
				/>
			)}
		</>
	);
};

PreviewNotes.propTypes = {
	hiddenByCompanyKind: PropTypes.number,
	warnings: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string, estimatedMatches: PropTypes.number })),
	companyKinds: PropTypes.arrayOf(PropTypes.string),
	onCompanyKindsChange: PropTypes.func,
};

export default PreviewNotes;
